import Input from 'components/Input';
import styled from 'styled-components';

export const InputName = styled(Input).attrs({
  id: "contactNameAdditional",
  stateName: "contactNameAdditional",
  className: "w-100",
  type: "text",
  name: "Nome do contato",
  placeholder: "Nome do contato",
  required: true
})``;

export const InputEmail = styled(Input).attrs({
  id: "contactMailAddressAdditional",
  stateName: "contactMailAddressAdditional",
  className: "w-100",
  type: "email",
  placeholder: "E-mail",
  required: true
})``;

export const InputPhone = styled(Input).attrs({
  id: "contactPhoneNumberAdditional",
  stateName: "contactPhoneNumberAdditional",
  className: "w-100 w-md-100",
  type: "telphone",
  placeholder: "Telefone"
})``;